import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { switchMap, delay } from 'rxjs/operators';
import { environment } from '@env/environment';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  private secureRoutes = [
    environment.mapsBackendApi, // maps-backend API, via Angular proxy
    environment.avatarUrl, // Avatar service
    environment.profileUrl // Profile service
  ];
  constructor(private oauthService: OAuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.isSecureRoute(req.url)) {
      return next.handle(req);
    }
    const accessToken = this.oauthService.getAccessToken();
    if (accessToken) {
      const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${accessToken}`
          }
      });
      return next.handle(authReq);
    }
    return next.handle(req);
  };

  /**
   * @param url The request URL.
   * @returns True if the URL should have a token attached.
   */
  private isSecureRoute(url: string): boolean {
    // The `some` method checks if the url starts with any of the routes in the array.
    return this.secureRoutes.some(route => route && url.startsWith(route));
  }
}
